import WebApp from "@twa-dev/sdk";

/**
 * Dark mode rollout darvozasi: barcha sahifalar semantic tokenlarga
 * migratsiya bo'lgunicha false turadi (Phase 5'da true qilinadi).
 * false bo'lsa app har doim light rejimda ishlaydi.
 */
const FOLLOW_TELEGRAM = false;

export type Theme = "light" | "dark";

const listeners = new Set<(theme: Theme) => void>();

function resolveTheme(): Theme {
  if (!FOLLOW_TELEGRAM) return "light";
  return WebApp.colorScheme === "dark" ? "dark" : "light";
}

function applyTheme(theme: Theme) {
  document.documentElement.dataset.theme = theme;

  // Telegram header/background'ni app foniga moslash
  const bg = getComputedStyle(document.documentElement)
    .getPropertyValue("--bg-app")
    .trim();
  try {
    if (bg.startsWith("#")) {
      WebApp.setHeaderColor(bg as `#${string}`);
      WebApp.setBackgroundColor(bg as `#${string}`);
    }
  } catch {
    // Eski Telegram versiyalari qo'llab-quvvatlamaydi
  }

  listeners.forEach((listener) => listener(theme));
}

export function initTheme() {
  applyTheme(resolveTheme());
  WebApp.onEvent("themeChanged", () => applyTheme(resolveTheme()));
}

export function getTheme(): Theme {
  return (document.documentElement.dataset.theme as Theme) || "light";
}

/** Theme o'zgarishiga obuna; unsubscribe funksiyasini qaytaradi */
export function onThemeChange(listener: (theme: Theme) => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
